<div class="wf-task">
	<div class="d-inline-block bg-light-purple py-2 px-3 mb-3 me-3 rounded-panel">
		<div class="form-check form-switch">
			<input type="checkbox" class="form-check-input" id="displayConditionsInput" [(ngModel)]="displayConditions"
				(ngModelChange)="conditionsToggled()">
			<label class="form-check-label" for="displayConditionsInput">
				<strong>
					Add Conditions
				</strong>
			</label>
		</div>
	</div>
	@if(displayConditions) {
		<h5 class="d-inline-block">
			Set conditions below, then add the Tasks to be assigned when the conditions are true.
		</h5>
		<rl-task-condition-builder [charTypeId]="charTypeId()" [queryNode]="form.controls.queryNode.value"
			(queryNodeChange)="onQueryNodeChange($event)">
		</rl-task-condition-builder>
	}

	<div class="task-set task-set__head d-flex mt-4 mb-2">
		<div class="w-30 px-3">TASK</div>
		<div class="w-30 px-3">ASSIGN TO</div>
	</div>

	@for(assignmentFormGroup of form.controls.assignments.controls; let index = $index; track assignmentFormGroup.controls.id.value) {
		<div class="d-flex rounded-panel border mb-2 overflow-hidden">
			<div class="w-30 p-3">
				<div class="mb-2"
					[class.has-error]="assignmentFormGroup.controls.taskName.invalid && (assignmentFormGroup.controls.taskName.dirty || assignmentFormGroup.controls.taskName.touched)">
					<rl-text-input [formControl]="assignmentFormGroup.controls.taskName" [dataLabel]="'TaskName'"
						[placeholder]="'Enter Task Name'"></rl-text-input>
					@if (assignmentFormGroup.controls.taskName.invalid && (assignmentFormGroup.controls.taskName.dirty || assignmentFormGroup.controls.taskName.touched)) {
						<small class="help-block">Task name is required.</small>
					}
				</div>
				<rl-text-area [formControl]="assignmentFormGroup.controls.description" [placeholder]="'Enter Description'"
					[showCounter]="true" [styles]="{maxLength: 10000}"></rl-text-area>
			</div>
			<div class="w-30 p-3">
				@for(assigneeControl of assignmentFormGroup.controls.assignees.controls; let assigneeIndex = $index; track assigneeIndex) {
					<div class="d-flex align-items-start"
						[class.has-error]="assigneeControl.invalid && (assigneeControl.dirty || assigneeControl.touched)">
						<div class="flex-fill mb-3">
							<rl-dropdown-single [formControl]="assigneeControl.controls.assigneeType"
								[options]="assigneeTypeOptions" [dataLabel]="'AssigneeDropdown'">
							</rl-dropdown-single>
							<div class="d-flex gap-2 mt-2">
								@switch(assigneeControl.controls.assigneeType.value.key) {
									@case(assigneeType.WorkflowRole) {
										<rl-dropdown-single [formControl]="assigneeControl.controls.assigneeRole"
											[options]="roleOptions()" [dataLabel]="'AssigneeRoleDropdown'"
											[showEmptyOption]="true" class="flex-fill">
										</rl-dropdown-single>
									}
									@case(assigneeType.Users) {
										<rl-typeahead-input [formControl]="assigneeControl.controls.assigneeUser"
											[searchFn]="userSearchFn" [labelFn]="userLabelFn" [keyFn]="userKeyFn"
											[placeholder]="'Search users...'" [pageSize]="10" class="flex-fill">
										</rl-typeahead-input>
									}
									@case(assigneeType.Party) {
										<rl-dropdown-single [formControl]="assigneeControl.controls.assigneeCharType"
											[options]="charTypeOptions()" [showEmptyOption]="true"
											[dataLabel]="'AssigneeRecordTypeDropdown'" class="w-50">
										</rl-dropdown-single>
										<rl-dropdown-single [formControl]="assigneeControl.controls.assigneeParty"
											[options]="getPartyOptionsForCharType(assigneeControl.controls.assigneeCharType.value?.charTypeID)"
											[showEmptyOption]="true" [dataLabel]="'AssigneePartyDropdown'" class="w-50">
										</rl-dropdown-single>
									}
								}
							</div>
						</div>

						<button (click)="deleteAssignee(assignmentFormGroup, assigneeIndex)"
							class="btn btn-icon btn-remove ms-2" title="Remove Assignee"
							[class.invisible]="assignmentFormGroup.controls.assignees.controls.length < 2">
							<i class="fal fa-xmark"></i>
						</button>
					</div>
				}
				<button class="btn btn-link btn-sm px-0 mt-1" (click)="addAssignee(assignmentFormGroup)">+ Add
					Assignee</button>
			</div>
			<div class="bg-light p-3 pe-0 flex-fill">
				<div class="d-flex align-items-start gap-2 mb-2"
					[class.has-error]="assignmentFormGroup.controls.requiredCompletions.invalid && (assignmentFormGroup.controls.requiredCompletions.dirty || assignmentFormGroup.controls.requiredCompletions.touched)">
					<strong class="w-140px text-end mt-35rem">Required Completions</strong>
					<div class="w-25">
						<rl-number-input [formControl]="assignmentFormGroup.controls.requiredCompletions"
							[dataLabel]="'RequiredCompletionsInput'"></rl-number-input>
						@if (assignmentFormGroup.controls.requiredCompletions.invalid && (assignmentFormGroup.controls.requiredCompletions.dirty ||
												assignmentFormGroup.controls.requiredCompletions.touched)) {
							<small class="help-block">Must be at least 1.</small>
						}
					</div>
					<div class="form-check mt-1">
						<input type="checkbox" class="form-check-input"
							[formControl]="assignmentFormGroup.controls.overrideCompletions"
							[id]="'overrideCompletions' + index"
							(change)="syncOverridePopover(overridePopover, $any($event.target).checked)">
						<label class="form-check-label small" [for]="'overrideCompletions' + index"
							[ngbPopover]="overridePopoverContent" #overridePopover="ngbPopover" triggers="manual"
							[autoClose]="false" placement="top" container="body"
							popoverClass="override-popover">Override</label>
						<ng-template #overridePopoverContent>
							<div class="position-absolute">
								<button type="button" class="btn btn-sm btn-close" title="Close" aria-label="Close"
									(click)="overridePopover.close()" data-cy="closeOverridePopover">
									<i class="fa fa-sm fa-xmark" aria-hidden="true"></i>
								</button>
							</div>
							When checked, all tasks on this Task Rule will be marked complete when this task is
							completed.
						</ng-template>
					</div>
				</div>


				<div class="d-flex align-items-center gap-2 mb-2">
					<strong class="w-140px text-end">Sequence</strong>
					<rl-dropdown-single class="w-25" [formControl]="assignmentFormGroup.controls.sequence"
						[options]="sequenceOptions" [dataLabel]="'SequenceDropdown'"></rl-dropdown-single>
				</div>

				<div class="d-flex align-items-start gap-2"
					[class.has-error]="assignmentFormGroup.controls.dueDateQuantity.invalid && (assignmentFormGroup.controls.dueDateQuantity.dirty || assignmentFormGroup.controls.dueDateQuantity.touched)">
					<strong class="w-140px text-end mt-35rem">Due Date</strong>
					<div class="w-25">
						<rl-number-input [formControl]="assignmentFormGroup.controls.dueDateQuantity"
							[dataLabel]="'NumDateInput'"></rl-number-input>
						@if (assignmentFormGroup.controls.dueDateQuantity.invalid && (assignmentFormGroup.controls.dueDateQuantity.dirty || assignmentFormGroup.controls.dueDateQuantity.touched)) {
							<small class="help-block">Must be 0 or greater.</small>
						}
					</div>
					<rl-dropdown-single [formControl]="assignmentFormGroup.controls.dueDateIncrements"
						[options]="dueDateIncrementsOptions" [dataLabel]="'DateTypeDropdown'"></rl-dropdown-single>
					<span class="mt-45rem small">after assignment</span>
				</div>
			</div>
			@if (form.controls.assignments.controls.length > 1) {
				<div class="bg-light">
					<button class="btn btn-icon btn-remove mt-2 me-2" title="Remove Task"
						(click)="deleteAssignment(index)">
						<i class="fal fa-xmark"></i>
					</button>
				</div>
			}

		</div>

	}

	<div>
		<button class="btn btn-link" (click)="addAssignment()" data-cy="addTaskBtn">+ Add Task</button>
	</div>

</div>